// /**
//  * 
//  * Radio Box
//  * 
//  */

// import React from 'react';

//  class RadioBox extends React.Component {

//      render() {
//          return (<div>
//              Radio box
//          </div>)
//      }
//  }


//  export default RadioBox;




//new by TF1 

/**
 *
 * Radio Box
 *
 */

import React from 'react';
import { RadioButton } from 'primereact/radiobutton';

class RadioBox extends React.Component {

    render() {

        const {
            name,
            label,
            value,
            options =[],
            onInputChange,
            disabled
        } = this.props;

        return (
            <div className="p-col-12">

                <label className="label">
                    {label}
                </label>

                <div className="mt1">

                  {options.map((item, index) => (
                        <span key={index}>
                            <RadioButton
                                inputId={`${name}_${index}`}
                                name={name}
                                value={item.value}
                                checked={value === item.value}
                                onChange={(e) =>
                                    onInputChange({
                                        target: { name },
                                        value: e.value
                                    })
                                }
                            />
                            <label htmlFor={`${name}_${index}`}>
                                {item.label}
                            </label>
                        </span>
                    ))}

                </div>

            </div>
        );
    }
}

export default RadioBox;